import { TypographyXS } from "@/components/typography/XS";
import { Button } from "@/components/ui/button";
import Card from "@/components/ui/card";
import { Link } from "@tanstack/react-router";
import { ArrowRight } from "lucide-react";
import { useLocalStorage } from "usehooks-ts";

export function OrganizationSelectLink() {
  const [, setLatestOrganization] = useLocalStorage<string | null>(
    "latestOrganizationSlug",
    null
  );

  return (
    <Card className="min-w-[30%] w-full max-w-lg p-4 flex justify-between gap-x-8 items-center">
      <TypographyXS>
        Select an organization to get started with Numerous.
      </TypographyXS>
      <Link to="/organization" onClick={() => setLatestOrganization(null)}>
        <Button variant="secondary">
          Select organization <ArrowRight size={14} className="ml-2" />
        </Button>
      </Link>
    </Card>
  );
}
